// extracted by mini-css-extract-plugin
export default {"wrapper":"Label_wrapper__0ZScN"};